/**
 * Load the active Generic Report Template and letterhead resources for Print Note.
 * Each fetch is optional. Failure returns a null template so the existing
 * Note Report layout remains usable.
 */
import { getAppointment, listSchedulingProviders } from "@/lib/appointmentApi";
import { getGenericReportTemplate } from "@/lib/genericReportTemplateApi";
import { api } from "@/lib/orgApi";
import {
  firstLocationId,
  firstOrganizationId,
  resourceRefId,
} from "@/lib/noteReportShell";

export async function loadNoteReportContext({ encounter, patient } = {}) {
  const empty = {
    template: null,
    organization: null,
    location: null,
    appointment: null,
    providerUser: null,
  };
  try {
    const [template, organizations, locations] = await Promise.all([
      getGenericReportTemplate().catch(() => null),
      api.get("/organizations").then((r) => r.data.items || []).catch(() => []),
      api.get("/locations").then((r) => r.data.items || []).catch(() => []),
    ]);
    const locationId = firstLocationId(encounter);
    const location = locations.find((item) => item.id === locationId) || null;
    const organizationId = firstOrganizationId({ encounter, patient, location });
    const organization = organizations.find((item) => item.id === organizationId) || null;
    const appointmentId =
      encounter?.appointmentId || resourceRefId(encounter?.appointment);
    const appointment = appointmentId
      ? await getAppointment(appointmentId).catch(() => null)
      : null;
    let providerUser = null;
    if (appointment?.providerUserId) {
      const providers = await listSchedulingProviders().catch(() => []);
      providerUser = providers.find((item) => item.id === appointment.providerUserId) || null;
    }
    return {
      template: template || null,
      organization,
      location,
      appointment,
      providerUser,
    };
  } catch {
    return empty;
  }
}
